import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { kr, dato, idag } from '../lib/format';
import { PageHeader, Card, Modal } from '../components/ui';
import { Plus, Trash2, TrendingUp, ArrowLeft, RefreshCw } from 'lucide-react';

const tom = () => ({ navn: '', isin: '', ticker: '', type: 'aksje',
  valuta: 'NOK', konto: 1830, siste_kurs: 0, notater: '' });
const tomT = () => ({ dato: idag(), type: 'kjop', antall: 0, kurs: 0,
  gebyr: 0, valutakurs: 1, kommentar: '' });

const Verdipapirer = () => {
  const [liste, setListe] = useState(null);
  const [valgt, setValgt] = useState(null);
  const [open, setOpen] = useState(false);
  const [s, setS] = useState(tom());
  const last = () => api.get('/verdipapirer').then((r) => setListe(r.data));
  useEffect(() => { last(); }, []);
  const lagre = async () => {
    if (!s.navn) { alert('Navn må fylles inn.'); return; }
    await api.post('/verdipapirer', s); setOpen(false); last();
  };
  const slett = async (v) => {
    if (!window.confirm(`Slette ${v.navn}? (Alle transaksjoner slettes.)`)) return;
    await api.delete(`/verdipapirer/${v.id}`); last();
  };
  if (!liste) return <span className="fm-text-muted">Laster…</span>;
  if (valgt) return <PapirDetalj id={valgt} onBack={() => { setValgt(null); last(); }} />;
  const sumMV = liste.reduce((s, v) => s + (v.markedsverdi || 0), 0);
  const sumKost = liste.reduce((s, v) => s + (v.kostpris || 0), 0);
  return (
    <>
      <PageHeader title="Aksjer & verdipapirer" subtitle="Portefølje med GAV, markedsverdi og utbytte"
        actions={
          <button className="btn-primary" onClick={() => { setS(tom()); setOpen(true); }}>
            <Plus size={14} /> Nytt papir
          </button>
        } />
      <div className="grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 12 }}>
        <Card style={{ padding: 14 }}>
          <div className="fm-text-muted" style={{ fontSize: 11 }}>Kostpris totalt</div>
          <div style={{ fontWeight: 700 }}>{kr(sumKost)}</div></Card>
        <Card style={{ padding: 14 }}>
          <div className="fm-text-muted" style={{ fontSize: 11 }}>Markedsverdi</div>
          <div style={{ fontWeight: 700 }}>{kr(sumMV)}</div></Card>
        <Card style={{ padding: 14 }}>
          <div className="fm-text-muted" style={{ fontSize: 11 }}>Urealisert gevinst</div>
          <div style={{ fontWeight: 700,
            color: sumMV - sumKost >= 0 ? 'var(--theme-success)' : 'var(--theme-danger)' }}>
            {kr(sumMV - sumKost)}</div></Card>
      </div>
      <Card style={{ padding: 0 }}>
        {liste.length === 0 ? (
          <div style={{ padding: 24, textAlign: 'center' }}>
            <TrendingUp size={32} className="fm-text-muted" />
            <p className="fm-text-muted" style={{ fontSize: 13 }}>Ingen verdipapirer registrert.</p>
          </div>
        ) : (
          <table>
            <thead><tr>
              <th>Navn</th><th>Type</th>
              <th style={{ textAlign: 'right' }}>Antall</th>
              <th style={{ textAlign: 'right' }}>GAV</th>
              <th style={{ textAlign: 'right' }}>Kurs</th>
              <th style={{ textAlign: 'right' }}>Markedsverdi</th>
              <th style={{ textAlign: 'right' }}>Urealisert</th>
              <th style={{ textAlign: 'right' }}>Utbytte</th>
              <th></th>
            </tr></thead>
            <tbody>
              {liste.map((v) => (
                <tr key={v.id}>
                  <td><a onClick={() => setValgt(v.id)}
                         style={{ cursor: 'pointer', color: 'var(--theme-accent)' }}>
                    <b>{v.navn}</b>
                    {v.ticker && <span className="fm-text-muted" style={{ fontSize: 11, marginLeft: 6 }}>
                      {v.ticker}</span>}
                  </a></td>
                  <td>{v.type}</td>
                  <td style={{ textAlign: 'right' }}>{(v.antall || 0).toLocaleString('no')}</td>
                  <td style={{ textAlign: 'right' }}>{kr(v.gav)}</td>
                  <td style={{ textAlign: 'right' }}>{kr(v.siste_kurs)}</td>
                  <td style={{ textAlign: 'right' }}>{kr(v.markedsverdi)}</td>
                  <td style={{ textAlign: 'right',
                    color: (v.urealisert_gevinst || 0) >= 0 ? 'var(--theme-success)' : 'var(--theme-danger)' }}>
                    {kr(v.urealisert_gevinst)}</td>
                  <td style={{ textAlign: 'right' }}>{kr(v.utbytte_total)}</td>
                  <td><button className="btn-ghost" onClick={() => slett(v)}>
                    <Trash2 size={14} style={{ color: 'var(--theme-danger)' }} />
                  </button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
      <Modal open={open} onClose={() => setOpen(false)} title="Nytt verdipapir" width={560}
             footer={<>
               <button className="btn-ghost" onClick={() => setOpen(false)}>Avbryt</button>
               <button className="btn-primary" onClick={lagre}>Lagre</button>
             </>}>
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div style={{ gridColumn: '1 / -1' }}><label>Navn *</label>
            <input value={s.navn} onChange={(e) => setS({ ...s, navn: e.target.value })} /></div>
          <div><label>Ticker</label>
            <input value={s.ticker} onChange={(e) => setS({ ...s, ticker: e.target.value })} /></div>
          <div><label>ISIN</label>
            <input value={s.isin} onChange={(e) => setS({ ...s, isin: e.target.value })} /></div>
          <div><label>Type</label>
            <select value={s.type} onChange={(e) => setS({ ...s, type: e.target.value })}>
              <option value="aksje">Aksje</option>
              <option value="fond">Fond</option>
              <option value="obligasjon">Obligasjon</option>
              <option value="krypto">Krypto</option>
              <option value="annet">Annet</option>
            </select></div>
          <div><label>Valuta</label>
            <input value={s.valuta} onChange={(e) => setS({ ...s, valuta: e.target.value })} /></div>
          <div><label>Konto</label>
            <input type="number" value={s.konto}
                   onChange={(e) => setS({ ...s, konto: parseInt(e.target.value || 1830) })} /></div>
          <div><label>Siste kurs</label>
            <input type="number" step="0.0001" value={s.siste_kurs}
                   onChange={(e) => setS({ ...s, siste_kurs: parseFloat(e.target.value || 0) })} /></div>
        </div>
      </Modal>
    </>
  );
};

const PapirDetalj = ({ id, onBack }) => {
  const [vp, setVp] = useState(null);
  const [trans, setTrans] = useState([]);
  const [open, setOpen] = useState(false);
  const [s, setS] = useState(tomT());
  const [nyKurs, setNyKurs] = useState('');
  const last = () => {
    api.get(`/verdipapirer/${id}`).then((r) => { setVp(r.data); setNyKurs(r.data.siste_kurs || ''); });
    api.get(`/verdipapirer/${id}/transaksjoner`).then((r) => setTrans(r.data));
  };
  useEffect(() => { last(); }, [id]);
  const lagreT = async () => {
    await api.post(`/verdipapirer/${id}/transaksjoner`, s); setOpen(false); last();
  };
  const slettT = async (t) => {
    if (!window.confirm('Slette transaksjon?')) return;
    await api.delete(`/verdipapirer/transaksjoner/${t.id}`); last();
  };
  const oppdaterKurs = async () => {
    await api.put(`/verdipapirer/${id}`, { siste_kurs: parseFloat(nyKurs || 0),
      siste_kurs_dato: idag() }); last();
  };
  if (!vp) return <span className="fm-text-muted">Laster…</span>;
  return (
    <>
      <button className="btn-ghost" onClick={onBack}><ArrowLeft size={14} /> Tilbake</button>
      <PageHeader title={vp.navn} subtitle={`${vp.ticker || ''} ${vp.isin || ''} • ${vp.type}`} />
      <Card style={{ marginBottom: 12, padding: 12 }}>
        <div className="flex items-center" style={{ gap: 8 }}>
          <RefreshCw size={16} />
          <label style={{ margin: 0 }}>Ny kurs:</label>
          <input type="number" step="0.0001" value={nyKurs} style={{ width: 140 }}
                 onChange={(e) => setNyKurs(e.target.value)} />
          <button className="btn-secondary" onClick={oppdaterKurs}>Oppdater</button>
          {vp.siste_kurs_dato && <span className="fm-text-muted" style={{ fontSize: 12 }}>
            (sist {dato(vp.siste_kurs_dato)})</span>}
          <span style={{ flex: 1 }} />
          <button className="btn-primary" onClick={() => { setS(tomT()); setOpen(true); }}>
            <Plus size={14} /> Ny transaksjon
          </button>
        </div>
      </Card>
      <Card style={{ padding: 0 }}>
        {trans.length === 0 ? (
          <div style={{ padding: 20, textAlign: 'center' }} className="fm-text-muted">
            Ingen transaksjoner.
          </div>
        ) : (
          <table>
            <thead><tr>
              <th>Dato</th><th>Type</th>
              <th style={{ textAlign: 'right' }}>Antall</th>
              <th style={{ textAlign: 'right' }}>Kurs</th>
              <th style={{ textAlign: 'right' }}>Gebyr</th>
              <th style={{ textAlign: 'right' }}>Sum NOK</th>
              <th></th>
            </tr></thead>
            <tbody>
              {trans.map((t) => (
                <tr key={t.id}>
                  <td>{dato(t.dato)}</td>
                  <td><span className="badge badge-neutral">{t.type}</span></td>
                  <td style={{ textAlign: 'right' }}>{(t.antall || 0).toLocaleString('no')}</td>
                  <td style={{ textAlign: 'right' }}>{kr(t.kurs)}</td>
                  <td style={{ textAlign: 'right' }}>{kr(t.gebyr)}</td>
                  <td style={{ textAlign: 'right' }}>{kr(t.sum_nok)}</td>
                  <td><button className="btn-ghost" onClick={() => slettT(t)}>
                    <Trash2 size={14} style={{ color: 'var(--theme-danger)' }} />
                  </button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
      <Modal open={open} onClose={() => setOpen(false)} title="Ny transaksjon" width={520}
             footer={<>
               <button className="btn-ghost" onClick={() => setOpen(false)}>Avbryt</button>
               <button className="btn-primary" onClick={lagreT}>Lagre</button>
             </>}>
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div><label>Dato</label>
            <input type="date" value={s.dato} onChange={(e) => setS({ ...s, dato: e.target.value })} /></div>
          <div><label>Type</label>
            <select value={s.type} onChange={(e) => setS({ ...s, type: e.target.value })}>
              <option value="kjop">Kjøp</option>
              <option value="salg">Salg</option>
              <option value="utbytte">Utbytte</option>
              <option value="splitt">Splitt (multiplikator)</option>
            </select></div>
          <div><label>Antall</label>
            <input type="number" step="0.0001" value={s.antall}
                   onChange={(e) => setS({ ...s, antall: parseFloat(e.target.value || 0) })} /></div>
          <div><label>Kurs</label>
            <input type="number" step="0.0001" value={s.kurs}
                   onChange={(e) => setS({ ...s, kurs: parseFloat(e.target.value || 0) })} /></div>
          <div><label>Gebyr</label>
            <input type="number" step="0.01" value={s.gebyr}
                   onChange={(e) => setS({ ...s, gebyr: parseFloat(e.target.value || 0) })} /></div>
          <div><label>Valutakurs</label>
            <input type="number" step="0.0001" value={s.valutakurs}
                   onChange={(e) => setS({ ...s, valutakurs: parseFloat(e.target.value || 1) })} /></div>
          <div style={{ gridColumn: '1 / -1' }}><label>Kommentar</label>
            <textarea rows={2} value={s.kommentar}
                      onChange={(e) => setS({ ...s, kommentar: e.target.value })} /></div>
        </div>
      </Modal>
    </>
  );
};

export default Verdipapirer;
